import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCampaignEmailHub } from './CampaignEmailHubContext';
import { fetchCampaignById } from '../../../api/campaigns';
import Button from '../../../components/ui/Button';
import CampaignEmailSendWizard from '../../../components/campaigns/CampaignEmailSendWizard';

export default function CampaignEmailSendRoute() {
  const { id, templateId: templateIdParam } = useParams();
  const hub = useCampaignEmailHub();
  const [campaign, setCampaign] = useState(hub.campaign || null);
  const navigate = useNavigate();

  useEffect(() => {
    if (hub.campaign) {
      setCampaign(hub.campaign);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchCampaignById(id);
        if (!cancelled) setCampaign(res?.data?.campaign || null);
      } catch (e) {
        console.error(e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, hub.campaign]);

  const cid = campaign?._id || campaign?.id || id;
  const base = `/campaigns/${encodeURIComponent(cid)}/email`;
  const initialTemplateId = templateIdParam || '';

  if (!campaign) {
    return <p className="text-sm text-muted-foreground">Chargement…</p>;
  }

  return (
    <div className="w-full min-w-0">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Envoi</p>
          <h2 className="text-xl font-semibold text-foreground">Emailing campagne</h2>
        </div>
        <Button type="button" variant="outline" onClick={() => navigate(base)}>
          Retour à la bibliothèque
        </Button>
      </div>
      <CampaignEmailSendWizard
        layout="page"
        mode="campaign"
        campaign={campaign}
        initialTemplateId={initialTemplateId}
        onClose={() => navigate(base)}
        onSuccess={() => navigate(base)}
      />
    </div>
  );
}
